import { useMutation } from '@tanstack/react-query';
import {
  TransferWithEvidenceService,
  RejectTransferRequestsDto,
  RejectTransferRequestEntity,
} from 'services/openapi';

export const useRejectTransferRequestMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<RejectTransferRequestEntity, Error, RejectTransferRequestsDto>({
      mutationFn: (variables: RejectTransferRequestsDto) =>
        TransferWithEvidenceService.transferWithEvidenceControllerReject(
          variables,
        ),
    });

  return { isLoading, isSuccess, error, data, isError, mutate, mutateAsync };
};
